import raveExp from '@magalu/rave/template/rave-exp';
import unique from '../../parser/route/unique';
import numberParser from '@magalu/rave/parser/number-parser';
import reviewRating from '../../parser/route/review-rating';

export const getComponents = props => ({
    'header-preconnect-0': {
      name: `Preconnect`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        list: [
          `https://wx.mlcdn.com.br`,
          `https://6590300.fls.doubleclick.net`,
          `https://a-static.mlcdn.com.br`,
          `https://ad.doubleclick.net`,
          `https://analytics.pangle-ads.com`,
          `https://analytics.tiktok.com`,
          `https://analytics.twitter.com`,
          `https://bat.bing.com`,
          `https://c.bing.com`,
          `https://c.clarity.ms`,
          `https://cas.avalon.perfdrive.com`,
          `https://cdn.perfdrive.com`,
          `https://connect.facebook.net`,
          `https://ct.pinterest.com`,
          `https://d.clarity.ms`,
          `https://gum.criteo.com`,
          `https://i.btg360.com.br`,
          `https://s.pinimg.com`,
          `https://sc-static.net`,
          `https://script.hotjar.com`,
          `https://site-content.magazineluiza.com.br`,
          `https://static.ads-twitter.com`,
          `https://static.criteo.net`,
          `https://static.hotjar.com`,
          `https://t.co`,
          `https://tags.creativecdn.com`,
          `https://td.doubleclick.net`,
          `https://tom.mlcdn.com.br`,
          `https://tr.snapchat.com`,
          `https://tr6.snapchat.com`,
          `https://us.creativecdn.com`,
          `https://www.clarity.ms`,
          `https://www.facebook.com`,
        ],
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-preconnect-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-datadog-1': {
      name: `Datadog`,
      from: `@magalu/ecomm-components/rave/scripts/Datadog`,
      props: {
        applicationId: `ebdcd394-ea53-457c-8daf-5659efb01d31`,
        clientToken: `pub65a718f902aee0ef33f464f14d53b149`,
        service: `mixer-hybrid`,
        version: `v${props?.data?.version}`,
        sessionSampleRate: 10,
        sessionReplaySampleRate: 1,
        strategy: `lazyOnload`,
        serviceDomainUrl: `https://mixer-hybrid.magazineluiza.com.br`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-datadog-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-script-2': {
      name: `Script`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        src: `https://wx.mlcdn.com.br/shared/azion/azfp-63fe5.min.js`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-script-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-all-in-3': {
      name: `AllIn`,
      from: `@magalu/ecomm-components/rave/scripts/AllIn`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-all-in-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-criteo-4': {
      name: `Criteo`,
      from: `@magalu/ecomm-components/rave/scripts/Criteo`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-criteo-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-tik-tok-5': {
      name: `TikTok`,
      from: `@magalu/ecomm-components/rave/scripts/TikTok`,
      props: {
        id: `C1I87V1T0U322RQPSRKG`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-tik-tok-5`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-rtbhouse-6': {
      name: `RTBHouse`,
      from: `@magalu/ecomm-components/rave/scripts/RTBHouse`,
      props: {
        id: `msWukR4UlwKQouZSY8IT`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-rtbhouse-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-stewie-7': {
      name: `Stewie`,
      from: `@magalu/ecomm-components/rave/scripts/Stewie`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-stewie-7`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-spotify-ad-analytics-8': {
      name: `SpotifyAdAnalytics`,
      from: `@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics`,
      props: {
        id: `66f417c2d2344c0980e19d4e7f996073`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-spotify-ad-analytics-8`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-hotjar-9': {
      name: `Hotjar`,
      from: `@magalu/ecomm-components/rave/scripts/Hotjar`,
      props: {
        id: `4936838`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-hotjar-9`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-10': {
      name: `Loader`,
      from: `@magalu/ecomm-components/rave/Loader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-10`,
      spacing: {
      },
      ssr: false,
    },
    'header-state-loader-11': {
      name: `StateLoader`,
      from: `@magalu/ecomm-components/rave/StateLoader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-11`,
      spacing: {
      },
      ssr: false,
    },
    'header-event-page-view-dispatcher-12': {
      name: `EventPageViewDispatcher`,
      from: `@magalu/ecomm-components/rave/EventPageViewDispatcher`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-event-page-view-dispatcher-12`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-10-children-page-loading-0': {
      name: `PageLoading`,
      from: `@magalu/ecomm-components/components/PageLoading`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-10-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-state-loader-11-children-page-loading-0': {
      name: `PageLoading`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      from: `@magalu/ecomm-components/components/PageLoading`,
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-11-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `pt-lg flex flex-col bg-surface-container-lowest h-full`,
      },
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0`,
      spacing: {
      },
      ssr: false,
    },
    'content-row-0-children-empty-review-button-0': {
      name: `EmptyReviewButton`,
      from: `@magalu/ecomm-components/rave/EmptyReviewButton`,
      hide: true,
      props: {
        title: `Seja o primeiro a avaliar esse produto`,
        subtitle: `Esse produto ainda não tem avaliação`,
        className: `mx-xlg py-sm`,
        button: {
          label: `Avaliar o produto`,
          as: `a`,
          variant: `outline`,
          className: `font-sm-medium`,
          size: `medium`,
          href: `/r/${props?.route?.query?.slug}/${props?.route?.query?.productId}/${props?.route?.query?.categoryId}/${props?.route?.query?.subCategoryId}/`,
        },
      },
      csr: false,
      displayCondition: `hide`,
      hasSpacing: false,
      id: `content-row-0-children-empty-review-button-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      show: props?.data?.productRating?.userReviews?.items,
      props: {
        className: `flex-col gap-md px-md mb-md`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-0-children-row-1`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1-children-product-review-info-basic-0': {
      name: `ProductReviewInfoBasic`,
      from: `@magalu/ecomm-components/rave/ProductReviewInfoCard`,
      props: {
        title: `Avaliações dos clientes`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-row-1-children-product-review-info-basic-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1-children-review-stats-1': {
      name: `ReviewStats`,
      from: `@magalu/ecomm-components/rave/ReviewStats`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-row-1-children-review-stats-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1-children-row-2': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      show: props?.data?.productRating?.userReviews?.items,
      props: {
        className: `flex-col my-sm`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-0-children-row-1-children-row-2`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1-children-row-2-children-button-0': {
      name: `Button`,
      from: `@magalu/ecomm-components/rave/Button`,
      hide: true,
      props: {
        variant: `outline`,
        color: `primary`,
        label: `Escrever avaliação`,
        href: `/r/${props?.route?.query?.slug}/${props?.route?.query?.productId}/${props?.route?.query?.categoryId}/${props?.route?.query?.subCategoryId}/`,
        pushToSiteDomain: true,
        spa: true,
        eventButton: `review:selectcontent:write-review`,
        eventValue: {
          contentId: `escrever-avaliacao`,
        },
        navigationParams: {
          type: `review`,
          data: {
            sku: props?.route?.query?.productId,
            category: {
              id: props?.route?.query?.categoryId,
              sub_category: {
                id: props?.route?.query?.subCategoryId,
              },
            },
            action: `create`,
          },
        },
      },
      csr: false,
      displayCondition: `hide`,
      hasSpacing: false,
      id: `content-row-0-children-row-1-children-row-2-children-button-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1-children-row-3': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      show: props?.data?.productRating?.userReviews?.items,
      props: {
        className: `flex-col gap-xsm my-xsm`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-0-children-row-1-children-row-3`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1-children-row-3-children-product-review-media-carousel-0': {
      name: `ProductReviewMediaCarousel`,
      from: `@magalu/ecomm-components/components/ProductReviewMediaCarousel`,
      show: raveExp({
        '||': [
          {
            '??': [
              props?.data?.productRating?.userReviews?.items?.[0]?.product?.images?.[0],
              null,
            ],
          },
          {
            '??': [
              props?.data?.productRating?.userReviews?.items?.[0]?.product?.videos?.[0],
              null,
            ],
          },
        ],
      }),
      props: {
        items: props?.data?.productRating?.userReviews?.items,
        title: `Avaliações com fotos e vídeos`,
        charLimit: 300,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-0-children-row-1-children-row-3-children-product-review-media-carousel-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1-children-row-4': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      show: props?.data?.productRating?.userReviews?.items,
      props: {
        className: `flex-col gap-xsm mb-xsm`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-0-children-row-1-children-row-4`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1-children-row-4-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Comentário dos clientes`,
        as: `p`,
        className: `font-sm-medium`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-row-1-children-row-4-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1-children-row-4-children-review-filters-1': {
      name: `ReviewFilters`,
      from: `@magalu/ecomm-components/rave/ReviewFilters`,
      props: {
        reviewsByRating: props?.data?.productRating?.reviewsByRating,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-row-1-children-row-4-children-review-filters-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-1-children-row-4-children-review-listing-2': {
      name: `ReviewListing`,
      from: `@magalu/ecomm-components/rave/ReviewListing`,
      props: {
        page: props?.route?.query?.page,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-row-1-children-row-4-children-review-listing-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-2': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      show: props?.data?.productRating?.userReviews?.items,
      props: {
        className: `flex-col gap-xlg border-t-thin border-on-surface-8`,
      },
      csr: false,
      displayCondition: `show`,
      hasSpacing: false,
      id: `content-row-0-children-row-2`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-row-2-children-review-pagination-button-0': {
      name: `ReviewPaginationButton`,
      from: `@magalu/ecomm-components/rave/ReviewPaginationButton`,
      props: {
        label: `Ver mais avaliações`,
        page: props?.route?.query?.page,
        userReviews: props?.data?.productRating?.userReviews,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-row-2-children-review-pagination-button-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-version-tag-0': {
      name: `VersionTag`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `footer-version-tag-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-back-to-top-1': {
      name: `BackToTop`,
      from: `@magalu/ecomm-components/components/BackToTop`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `footer-back-to-top-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
  });

export const dataSource = {
  "graphql": {
    "configsDir": "config",
    "host": "https://federation.magazineluiza.com.br",
    "timeout": 5000
  }
}

export const getHeadProps = (props) => ({
    links: [
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/fonts/magalu-ui-variable/files/MagaluUIVariable.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.woff`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/truetype`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.ttf`,
        crossOrigin: ``,
      },
    ],
  });

export const componentsList = [
  "Preconnect",
  "Datadog",
  "Script",
  "AllIn",
  "Criteo",
  "TikTok",
  "RTBHouse",
  "Stewie",
  "SpotifyAdAnalytics",
  "Hotjar",
  "Loader",
  "StateLoader",
  "EventPageViewDispatcher",
  "PageLoading",
  "Row",
  "EmptyReviewButton",
  "ProductReviewInfoBasic",
  "ReviewStats",
  "Button",
  "ProductReviewMediaCarousel",
  "Heading",
  "ReviewFilters",
  "ReviewListing",
  "ReviewPaginationButton",
  "VersionTag",
  "BackToTop"
];

export const routeInfo = {
  id: 'review-list',
  name: 'review-list',
  pathPattern: '/review/:productId/:slug/:categoryId/:subCategoryId/',
  pathAliases: {
  "path1": "productId",
  "path2": "slug",
  "path3": "categoryId",
  "path4": "subCategoryId"
},
  parser: {
    query: {
      "seller_id": unique(),
      "page": numberParser({"fallback":1}),
      "filters": reviewRating({"separator":"---"}),
    },
    cookie: {},
  },
  renderMethod: 'SSR',
  forwardCookies: '',
  forwardHeaders: 'user-agent,referer,theme,x-forwarded-for'
};

export const manifest = {
  "useTypescript": true,
  "deepLinkHost": "https://m.magazineluiza.com.br",
  "isMiniApp": true
};

export const getGlobalClassName = props => ([
    `bg-surface-container-low`,
  ]).join(' ').trim();

export const getPageVariables = props => ({
    item_itemId: props?.route?.query?.productId,
    productRating_variationId: props?.route?.query?.productId,
    productRating_includeUserReviews: true,
    productRating_page: raveExp({
      '??': [
        props?.route?.query?.page,
        1,
      ],
    }),
    productRating_filters: props?.route?.query?.filters,
    productRating_sortType: props?.route?.query?.sortType,
    productRating_hasTag: true,
  });

export const middlewaresArgs = ({ 
      "getAppTheme": (props) => ({
  }),
      "webViewValidator": (props) => ({
    redirectUrl: `/404/`,
  }),
      "getUserInfo": (props) => ({
  }),
      "getVersions": (props) => ({
  }),
      "writePromoterIdCookie": (props) => ({
  }),
 });

export const config = {
  assetPrefix: '',
};
